export enum ELABORATION_ASS_ACTIONS {
  CREA_PRATICA,
  CREA_FASCICOLO,
  ASSOCIA,
  RIPRENDI
}
